import { Box, Grid2, Paper, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useFormStyles } from "../../../hooks/useFormStyles";
import { CapturePreview } from "../../../types/interfaces/file/imports/captures";

interface UploadCaptureFormProps {
  capture: CapturePreview;
}

export const UploadCaptureForm = ({ capture }: UploadCaptureFormProps) => {
  const { t } = useTranslation();
  const formStyles = useFormStyles(true);

  return (
    <Box>
      <Grid2 container spacing={3}>
        <Grid2 size={12}>
          <Paper sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6" mb={2}>
              {t("captures.capture.general.identification.title")}
            </Typography>

            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth 
                  label={t("captures.capture.general.identification.name")} 
                  value={capture.name} 
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.general.identification.entity")}
                  value={capture.entityName}
                  disabled
                  sx={{
                    ...formStyles,
                    "& .MuiInputBase-input": {
                      textTransform: "uppercase",
                    },
                  }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.general.identification.management-unit")}
                  value={capture.managementUnitName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.general.identification.aquaEsp-desig")}
                  value={capture.aquaEpsDesignation}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.general.identification.entity-desig")}
                  value={capture.entityDesignation}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.general.identification.licensing-desig")}
                  value={
                    capture.licensingDesignation
                      ? capture.licensingDesignationSystem
                        ? `${capture.licensingDesignationSystem}: ${capture.licensingDesignation}`
                        : capture.licensingDesignation
                      : ""
                  }
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.general.identification.supply-type")}
                  value={capture.capturePurposeData?.supplyTypeName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 6 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.general.identification.purpose")}
                  value={capture.capturePurposeData?.purposeName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>
            </Grid2>
          </Paper>
        </Grid2>

        <Grid2 size={12}>
          <Paper sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6" mb={2}>
              {t("captures.capture.general.location-details.title")}
            </Typography>

            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label="X (ETRS)"
                  value={capture.captureLocationData?.coordinates?.xETRS}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label="Y (ETRS)"
                  value={capture.captureLocationData?.coordinates?.yETRS}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label="Z (ETRS)"
                  value={capture.captureLocationData?.coordinates?.zETRS}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>
            </Grid2>
          </Paper>
        </Grid2>
        
        <Grid2 size={12}>
          <Paper sx={{ p: 3, borderRadius: 2 }}>
            <Typography variant="h6" mb={2}>
              {t("captures.capture.general.construction-details.title")}
            </Typography>

            <Grid2 container spacing={2}>
              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.general.construction-details.drilling-method")}
                  value={capture.constructionDetailsData?.drillingMethodName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.general.construction-details.casing-material")}
                  value={capture.constructionDetailsData?.casingMaterialName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>

              <Grid2 size={{ xs: 12, md: 4 }}>
                <TextField
                  fullWidth
                  label={t("captures.capture.general.identification.subsurface-capture")}
                  value={capture.constructionDetailsData?.subsurfaceCaptureTypeName}
                  disabled
                  sx={{ ...formStyles }}
                />
              </Grid2>
            </Grid2>
          </Paper>
        </Grid2>

      </Grid2>
    </Box>
  );
};
